import http from '../../utils/http';
const rootUrl = '/api';
const Product = {
	/**
	 * 解析c2v文件
	 * @param {*} data
	 */
	parseC2V( data ) {
		return http.post( `${rootUrl}/parseC2VV2`, {
			data,
			errCode: 'Product.parseC2V',
			headers: { 'Content-Type': 'application/octet-stream', isCsrf: true }
		});
	},
	/**
	 * 离线激活
	 */
	apply( data ) {
		return http.post( `${rootUrl}/productEDOfflineApply`, {
			data,
			errCode: 'Product.apply'
		}, { headers: { isCsrf: true } });
	},
	/**
	 * 绑定设备
	 * @param {String} modelCode
	 * @param {String} sn
	 */
	bind( data ) {
		return http.post( `${rootUrl}/edBind`, {
			data,
			errCode: 'Product.bind'
		}, { headers: { isCsrf: true } });
	},
	/**
	 * 我的设备列表
	 * @param {*} data
	 * @returns
	 */
	myProductList( params ) {
		return http.get( `${rootUrl}/productEDList`, { params });
	},
	/**
	 * 注销设备
	 * @param {String} edID
	 * @returns
	 */
	withdraw( params ) {
		return http.get( `${rootUrl}/withdrawEDV2`, { params });
	},
	/**
	 * 查询ed详情
	 * @param {String} edID
	 * @returns
	 */
	edDetail( params ) {
		return http.get( `${rootUrl}/productEDDetail`, { params });
	},
	/**
	 * 查询ed详情
	 * @param {String} edID
	 * @returns
	 */
	getV2C( data ) {
		return http.post( `${rootUrl}/downloadV2CV2`, { data });
	},
	/**
	 * 通行证网页用户自行延期
	 * @param {*} data
	 */
	offlineExtend( data ) {
		return http.post( `${rootUrl}/productEDOfflineExtend`, {
			data,
			errCode: 'Product.offlineExtend'
		}, { headers: { isCsrf: true } });
	},
	/**
	 * 获取token，获取验证码时使用
	 * @returns
	 */
	getToken( params ) {
		return http.get( `${rootUrl}/authToken`, { params, errCode: 'Product.getToken' });
	},
	/**
	 * 获取api token,用于免登陆接口
	 * @param {*} data
	 */
	getApiTokenFromNode() {
		return http.post( '/getApiToken', { errCode: 'commonApi.getApiTokenFromNode' });
	},
	/**
	 * 通行证, 查询型号详细信息
	 * modelCode lang
	 * @returns
	 */
	getModelDetail( params, { apiToken }) {
		return http.get( `${rootUrl}/queryModelDetailAPI`, {
			params,
			errCode: 'Product.getModelDetail',
			headers: { 'X-Auth-Token': apiToken } 
			
		});
	},
		/**
	 * dlp-h5 激活
	 * @param {*} data
	 */
	applyH5( data, { apiToken }) {
		return http.post(
			`${rootUrl}/applyNoC2V`, 
			{ data, errCode: 'Product.applyH5' }, 
			{ headers: { 'X-Auth-Token': apiToken, isCsrf: true } }
		);
	}
};

export default Product;
